var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_52463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 22,
    height: 22,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_52463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9974 21.9974C20.9891 21.9974 20.1259 21.6384 19.4078 20.9203C18.6898 20.2023 18.3307 19.3391 18.3307 18.3307C18.3307 17.3224 18.6898 16.4592 19.4078 15.7411C20.1259 15.0231 20.9891 14.6641 21.9974 14.6641C23.0057 14.6641 23.8689 15.0231 24.587 15.7411C25.305 16.4592 25.6641 17.3224 25.6641 18.3307C25.6641 19.3391 25.305 20.2023 24.587 20.9203C23.8689 21.6384 23.0057 21.9974 21.9974 21.9974ZM14.6641 29.3307V26.7641C14.6641 26.2446 14.7977 25.7672 15.0651 25.3318C15.3325 24.8964 15.6877 24.5641 16.1307 24.3349C17.078 23.8613 18.0405 23.5061 19.0182 23.2693C19.996 23.0325 20.9891 22.9141 21.9974 22.9141C23.0057 22.9141 23.9988 23.0325 24.9766 23.2693C25.9543 23.5061 26.9168 23.8613 27.8641 24.3349C28.3071 24.5641 28.6623 24.8964 28.9297 25.3318C29.197 25.7672 29.3307 26.2446 29.3307 26.7641V29.3307H14.6641ZM16.4974 27.4974H27.4974V26.7641C27.4974 26.596 27.4554 26.4432 27.3714 26.3057C27.2873 26.1682 27.1766 26.0613 27.0391 25.9849C26.2141 25.5724 25.3814 25.263 24.5411 25.0568C23.7009 24.8505 22.853 24.7474 21.9974 24.7474C21.1418 24.7474 20.2939 24.8505 19.4536 25.0568C18.6134 25.263 17.7807 25.5724 16.9557 25.9849C16.8182 26.0613 16.7075 26.1682 16.6234 26.3057C16.5394 26.4432 16.4974 26.596 16.4974 26.7641V27.4974ZM21.9974 20.1641C22.5016 20.1641 22.9332 19.9845 23.2922 19.6255C23.6512 19.2665 23.8307 18.8349 23.8307 18.3307C23.8307 17.8266 23.6512 17.395 23.2922 17.0359C22.9332 16.6769 22.5016 16.4974 21.9974 16.4974C21.4932 16.4974 21.0616 16.6769 20.7026 17.0359C20.3436 17.395 20.1641 17.8266 20.1641 18.3307C20.1641 18.8349 20.3436 19.2665 20.7026 19.6255C21.0616 19.9845 21.4932 20.1641 21.9974 20.1641Z",
    fill: "#07213C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutlinedIcon);
export default __webpack_public_path__ + "static/media/person-outlined-icon.8cbe1f5b35794e3b678a3d9a2e6ec3d7.svg";
export { ForwardRef as ReactComponent };